import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

declare var $;

@Component({
    selector: 'app-app-layout',
    templateUrl: './app-layout.component.html',
    styleUrls: ['./app-layout.component.css']
})
export class AppLayoutComponent implements OnInit ,AfterViewInit{

    title = 'ADCommerce';

    constructor(private router: Router) {


    }

    ngOnInit() {

        $('html').attr("dir","ltr");
        $('html').attr("lang","en");


    }

    ngAfterViewInit(): void {

        $('.mat-sidenav-content').css("margin-left","80px ");
        $('.mat-sidenav-content').css("margin-right","auto");
    }

}
